/* eslint-disable no-unreachable */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable default-param-last */
import initialState from '../initialState';
import { ADD_BOOK, DELETE_BOOK, LOADED_BOOK, UPDATE_BOOK } from './actionTypes';

const nextBookId = books => {
  const maxId = books.reduce((maxId, book) => Math.max(book.id, maxId), -1);
  return maxId + 1;
};

const bookStoreReducer = (state = initialState.books, action) => {
  switch (action.type) {
    case LOADED_BOOK:
      return [...state, ...action.payload];
    case ADD_BOOK:
      return [...state, { id: nextBookId, ...action.payload }];
    case DELETE_BOOK:
      return state.filter(book => book.id !== action.payload);
    case UPDATE_BOOK:
      return state.map(book => {
        if (book.id === action.payload.id) {
          return {
            ...book,
            ...action.payload,
          };
        }
        return book;
      });
    default:
      return state;
  }
};

export default bookStoreReducer;
